import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 } }),
};

const stats = [
  { k: "$150K", v: "Investment to own your dealership territory", span: "md:col-span-4" },
  { k: "$500K+", v: "Potential annual revenue*", span: "md:col-span-4" },
  { k: "40%", v: "Revenue stream on qualifying development projects", span: "md:col-span-4" },
];

export const Stats = () => {
  return (
    <section id="opportunity" className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-12 md:gap-8 items-end mb-16">
        <div className="md:col-span-7">
          <p className="text-xs uppercase tracking-[0.3em] text-oed-gold mb-6">The Opportunity</p>
          <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl leading-[1.05]">
            A business unlike anything else on the market.
          </h2>
        </div>
        <div className="md:col-span-5 md:col-start-9">
          <p className="text-base md:text-lg text-white/60 leading-relaxed">
            Become an OED Glampire Network Destination Dealership Owner and lead the fast-growing
            movement toward off-grid living, glamping resorts and sustainable development.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-12 gap-px bg-white/10 border border-white/10">
        {stats.map((s, i) => (
          <motion.div
            key={s.k}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            data-testid={`stat-card-${i}`}
            className={`${s.span} bg-oed-surface p-10 md:p-12`}
          >
            <p className="font-display font-black tracking-tighter text-5xl md:text-6xl">{s.k}</p>
            <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">{s.v}</p>
          </motion.div>
        ))}
      </div>
      <p className="mt-6 text-[11px] text-white/30 max-w-2xl leading-relaxed">
        *Revenue potential depends on market conditions, sales performance, execution and other
        business factors. Illustrative projection, not a guarantee of earnings.
      </p>
    </section>
  );
};
